<template>
  <div class="box__baseview">
    <div
      class="box__point"
      v-for="item in data"
      :id="item.point"
      :key="item.point"
    >
      <div class="box__point-title">
        <i :class="item.icon"></i><span>{{ item.title }}</span>
      </div>

      <div class="point__sublist">
        <div
          class="point__sublist-item"
          v-for="citem in item.children"
          :key="citem.name"
          @click="toExample(citem)"
        >
          <div class="point__sublist-item--title">
            <span>{{ citem.meta.title }}</span>
          </div>
          <div class="point__sublist-item--content">
            <img
              v-lazy="citem.meta.img || '../assets/logo.png'"
              :alt="citem.meta.title"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import menuData from "@/constant/menu";
export default {
  name: "BaseView",
  data() {
    return {
      data: Object.assign({}, menuData),
      baseImg: "",
    };
  },
  methods: {
    toExample(data) {
      window.open("#" + data.path);
    },
  },
};
</script>

<style lang="less" scoped>
.box__baseview {
  height: 100%;
  overflow: auto;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 5px;
  }

  .box__point {
    padding: 20px 20px 40px;
    .box__point-title {
      font-size: 24px;
      line-height: 50px;
      border-bottom: 2px solid #41b883;
      i {
        padding-right: 10px;
      }
    }
    .point__list {
      padding: 10px;
      border-bottom: 1px solid #41b883;
      padding-bottom: 30px;
      .point__list-title {
        font-size: 20px;
        line-height: 40px;
        padding: 20px 0;
      }
      &:last-child {
        border-bottom: none;
      }
    }
    .point__sublist {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      padding-top: 20px;
    }
    .point__sublist-item {
      cursor: pointer;
      position: relative;
      margin: 10px 30px 20px 0;
      border: 1px solid #d8d8d8;
      transition: all ease-in 0.2s 0.2s;
      .point__sublist-item--title {
        text-align: center;
        color: #fff;
        line-height: 40px;
        max-width: 200px;
        padding: 0 10px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        border-bottom: 1px solid #d8d8d8;
        background-color: rgb(0, 100, 255);
      }
      .point__sublist-item--content {
        padding: 10px;
        img {
          display: block;
          max-width: 200px;
        }
      }
      &:hover {
        transform: scale(1.1);
        box-shadow: 0 0 10px #aaa;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/BaseView.vue